import React, { useEffect, useState } from "react";
import GroupedBarChart from "../../../../../CHARTS/GroupedBarChart";
import NoDataFound from "../../../../../Extra/NoDataFound";
const AdrmSummeryGraph = ({ data, selectedData }) => {
  const [chartDataTRD, setChartDataTRD] = useState(null);
  const [chartDataSNT, setChartDataSNT] = useState(null);
  const [chartDataEngg, setChartDataEngg] = useState(null);
  const [selectedDept, setSelectedDept] = useState([]);
  const [lengthOfSlelDept, setLengthOfSlelDept] = useState(3);
  function getChartDataByDept(dept) {
    // Set default divisor
    let divideBy = { previousData: 1, currentData: 1 };

    if (selectedData.selectedMatrixField === "Avg per day") {
      divideBy = {
        previousData: data.previousData.length || 1, // avoid divide by 0
        currentData: data.currentData.length || 1,
      };
    } else if (selectedData.selectedMatrixField === "Avg per month") {
      divideBy = { previousData: 30, currentData: 30 };
    }

    const years = [
      ...new Set([
        ...data?.previousData.map((item) =>
          new Date(item.block_date).getFullYear()
        ),
        ...data.currentData.map((item) =>
          new Date(item.block_date).getFullYear()
        ),
      ]),
    ].sort(); // Ensure chronological order

    // Filter data by department
    const currentDeptData = data?.currentData.filter(
      (item) => item.dept === dept
    );
    const previousDeptData = data?.previousData.filter(
      (item) => item.dept === dept
    );

    // Initialize chart data
    const chartData = {
      dimensions: ["product", ...years.map(String)],
      series: [
        { product: "blocks_agreed" },
        { product: "hours_agreed" },
        { product: "blocks_granted" },
        { product: "hours_granted" },
      ],
    };

    // Calculate sums and apply division
    chartData.series.forEach((seriesItem) => {
      years.forEach((year) => {
        let yearData, divisor;

        if (
          year === new Date(data?.previousData[0]?.block_date).getFullYear()
        ) {
          yearData = previousDeptData;
          divisor = divideBy.previousData;
        } else {
          yearData = currentDeptData;
          divisor = divideBy.currentData;
        }

        const originalKey = `total_corridor_${seriesItem.product}`;
        const total = yearData
          .filter((item) => new Date(item.block_date).getFullYear() === year)
          .reduce((sum, item) => sum + (item[originalKey] || 0), 0);

        // Apply hours conversion + division
        const value =
          seriesItem.product === "hours_agreed" ||
          seriesItem.product === "hours_granted"
            ? total / 3600
            : total;

        seriesItem[String(year)] = (value / divisor).toFixed(0);
      });
    });

    return chartData;
  }
  useEffect(() => {
    if (selectedData?.selectedDept) {
      const dept =
        selectedData.selectedDept instanceof Set
          ? Array.from(selectedData.selectedDept)
          : Array.isArray(selectedData.selectedDept)
          ? [...selectedData.selectedDept]
          : [];

      setSelectedDept(dept);
      setLengthOfSlelDept(
        dept.length == 3 ? 4 : dept.length == 2 ? 6 : dept.length == 1 ? 12 : ""
      );
    }
  }, [selectedData]);

  useEffect(() => {
    if (data && data?.currentData?.length > 0) {
      const formattedData = getChartDataByDept("TRD");
      setChartDataTRD(formattedData);
      const formattedDataSnT = getChartDataByDept("S&T");
      setChartDataSNT(formattedDataSnT);
      const formattedDataEngg = getChartDataByDept("ENGG");
      setChartDataEngg(formattedDataEngg);
    }
  }, [data]);

  return (
    <div>
      {" "}
      <div className="">
        <div className="row ">
          {selectedDept.includes("ENGG") && (
            <div className={`col-md-4`}>
              <div className="m-1 papaDiv">
                <h5 className="bg-dark text-white">
                  {" "}
                  ENGINEERING{" "}
                  <b
                    style={{
                      color: "rgba(178, 178, 178, 1)",
                      fontSize: "15px",
                    }}
                  >
                    {selectedData.selectedMatrixField}
                  </b>
                </h5>
                {data.currentData.length > 0 &&
                chartDataEngg &&
                chartDataEngg.series.length > 0 ? (
                  <GroupedBarChart
                    data={chartDataEngg}
                    height={200}
                    from={`Block_C`}
                    rotateText={10}
                    chartType="bar"
                  />
                ) : (
                  <NoDataFound />
                )}
              </div>
            </div>
          )}
          {selectedDept.includes("TRD") && (
            <div className={`col-md-4`}>
              <div className="m-1 papaDiv">
                <h5 className="bg-dark text-white">
                  {" "}
                  TRD{" "}
                  <b
                    style={{
                      color: "rgba(178, 178, 178, 1)",
                      fontSize: "15px",
                    }}
                  >
                    {selectedData.selectedMatrixField}
                  </b>
                </h5>
                {data.currentData.length > 0 &&
                chartDataTRD &&
                chartDataTRD.series.length > 0 ? (
                  <GroupedBarChart
                    data={chartDataTRD}
                    height={200}
                    from={`Block_C`}
                    rotateText={10}
                    chartType="bar"
                  />
                ) : (
                  <NoDataFound />
                )}
              </div>
            </div>
          )}
          {selectedDept.includes("S&T") && (
            <div className={`col-md-4`}>
              <div className="m-1 papaDiv">
                <h5 className="bg-dark text-white">
                  {" "}
                  S&T{" "}
                  <b
                    style={{
                      color: "rgba(178, 178, 178, 1)",
                      fontSize: "15px",
                    }}
                  >
                    {selectedData.selectedMatrixField}
                  </b>
                </h5>
                {data.currentData.length > 0 &&
                chartDataSNT &&
                chartDataSNT.series.length > 0 ? (
                  <GroupedBarChart
                    data={chartDataSNT}
                    height={200}
                    from={`Block_C`}
                    rotateText={10}
                    chartType="bar"
                  />
                ) : (
                  <NoDataFound />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default AdrmSummeryGraph;
